export default __webpack_public_path__ + "static/media/nuevas_funciones.912e0705.svg";